export const getters = {
    getCargo: state => state.cargo,
    getCargos: state => state.cargos,
    getModalCadastroCargo: state => state.modalCadastroCargo,
    getModalExcluirCargo: state => state.modalExcluirCargo,
}

export default {}